import { render, staticRenderFns } from "./FormKTCForeverPlan.vue?vue&type=template&id=29830f8a&scoped=true&"
import script from "./FormKTCForeverPlan.vue?vue&type=script&lang=js&"
export * from "./FormKTCForeverPlan.vue?vue&type=script&lang=js&"
import style0 from "./FormKTCForeverPlan.vue?vue&type=style&index=0&id=29830f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29830f8a",
  null
  
)

export default component.exports